import { Instance } from 'mobx-state-tree'

import { UserInfoModelBase } from './UserInfoModel.base'

/* The TypeScript type of an instance of UserInfoModel */
export interface UserInfoModelType extends Instance<typeof UserInfoModel.Type> {}

/* A graphql query fragment builders for UserInfoModel */
export { selectFromUserInfo, userInfoModelPrimitives, UserInfoModelSelector } from './UserInfoModel.base'

/**
 * UserInfoModel
 */
export const UserInfoModel = UserInfoModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
